<p-drawer
  [visible]="display"
  position="right"
  appendTo="body"
  (onHide)="onHide()"
  header="{{ headingStatus ? createNewContact : updateNewContact }}">
  <div class="mb-2 left-sidebar clientdetails">
    <!-- <h1 class="mb-3" *ngIf="headingStatus">{{ createNewContact }}</h1>
    <h1 class="mb-3" *ngIf="!headingStatus">{{ updateNewContact }}</h1> -->
    <jni-address
      [parent]="vendorForm"
      [formgroupName]="'addressInformation'"
      [cityList]="cityList"
      [countryRegionList]="countryRegionList"
      [countyList]="countyList"
      [districtList]="districtList"
      [stateList]="stateList"
      [hiddenHeadingStatus]="true"
      [isPrimaryFieldStatus]="isPrimaryFieldStatus"
      [countryRegionSelectedId]="countryRegionIdD365"></jni-address>

    <p-button
      label="Save"
      *ngIf="
        !isFromVendorSummary || (isFromVendorSummary && loggedInUserIsAdmin)
      "
      (click)="onSubmit()"
      [disabled]="!vendorForm.valid" />
  </div>
</p-drawer>
